import React, { useState, useEffect } from "react";
import { observer, inject } from "mobx-react";
import { useTranslation } from "react-i18next";
import SearchHeader from "../layouts/SearchHeader";
import { Button, Tabs } from "../UI";
import { Tab } from "../UI/Tabs";
import LoadingContainer from "../layouts/LoadingContainer";
import Table from "../layouts/Table";
import { startOfMonth, endOfMonth, subMonths } from "date-fns";
import NewReportDetail from "../components/NewReportDetail";
import addImg from "../asserts/img/newReport.svg";
import ErrorNotification from "../components/ErrorNotification";

const ReportDetails = ({
  reportDetails,
  selectedReport,
  handelRowClick,
  handelRowDeleteClick,
  handelOpenNewReportClick,
  handleSearchChange,
  handleDateChange,
  inSearch,
  error,
}) => {
  const { t } = useTranslation("report_details");
  const [showNewReportModal, setShowNewReportModal] = useState(false);
  const [tab, setTab] = useState("1");
  const [showErrorNotification, setShowErrorNotification] = useState({
    show: false,
    text: "",
  });

  useEffect(() => {
    if (!!error) {
      setShowErrorNotification({
        show: true,
        text: error,
      });
    } else {
      setShowErrorNotification({
        show: false,
        text: "",
      });
    }
  }, [error]);

  const keys = [
    { key: "CURDATE", width: "10%", sort: true },
    { key: "CUSTDES", width: "15%", sort: true },
    { key: "ORDNAME", width: "8%", sort: true },
    { key: "PARTDES", width: "18%", sort: true },
    { key: "JOBDESC", width: "15%", sort: true },
    { key: "ZCOR_TASKDES", width: "6%", sort: true },
    { key: "ZCOR_DOCNO", width: "6%", sort: true },
    { key: "NO_CHARGE", width: "5%" },
    { key: "HOURS", width: "8%" },
    { key: "ACTIONS", width: "9%" },
  ];

  const openNewReport = () => {
    handelOpenNewReportClick();
    setShowNewReportModal(true);
  };

  const openReport = (report) => {
    handelRowClick(report);
    setShowNewReportModal(true);
  };

  return (
    <>
      <LoadingContainer>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            padding: "24px 50px",
            alignItems: "center",
            gap: 5
          }}>
          <SearchHeader
            handleDateChange={(date) => {
              handleDateChange(date);
              setTab("3");
            }}
            handleSearchChange={(search) => {
              handleSearchChange(search);
              setTab("3");
            }}
            title={t("report_details_title")}></SearchHeader>
          <Button
            onClick={openNewReport}
            style={{
              width: 140,
              justifyContent: "space-between",
              alignItems: "center",
              boxSizing: "border-box",
              display: "flex",
              paddingInline: 14,
            }}>
            <img src={addImg} alt="add" style={{ width: 18, height: 18 }} />
            {t("new_report")}
          </Button>
        </div>
        {
          <Tabs value={tab} tabChange={setTab}>
            <Tab value="1" label={t("current_month")}>
              <Table
                handelRowClick={openReport}
                handelRowDeleteClick={handelRowDeleteClick}
                hasDelete={true}
                tab={1}
                keys={keys}
                items={reportDetails?.filter((rep) => {
                  const date = new Date();
                  const reportDate = new Date(rep.CURDATE);

                  return (
                    reportDate.getTime() >= startOfMonth(date).getTime() &&
                    reportDate.getTime() <= endOfMonth(date).getTime()
                  );
                })}
                translation={"report_details"}
                config={{ key: "CURDATE", direction: "descending" }}
                style={{ margin: "0 50px" }}
              />
            </Tab>
            <Tab value="2" label={t("last_month")}>
              <Table
                handelRowClick={openReport}
                handelRowDeleteClick={handelRowDeleteClick}
                hasDelete={true}
                tab={2}
                keys={keys}
                items={reportDetails?.filter((rep) => {
                  const date = new Date();
                  const dateLastMonth = new Date(subMonths(date, 1));
                  const reportDate = new Date(rep.CURDATE);

                  return (
                    reportDate.getTime() >=
                      startOfMonth(dateLastMonth).getTime() &&
                    reportDate.getTime() <= endOfMonth(dateLastMonth).getTime()
                  );
                })}
                translation={"report_details"}
                config={{ key: "CURDATE", direction: "descending" }}
                style={{ margin: "0 50px" }}
              />
            </Tab>
            <Tab value="3" label={t("search_details")}>
              <Table
                handelRowClick={handelRowClick}
                handelRowDeleteClick={handelRowDeleteClick}
                hasDelete={true}
                tab={3}
                keys={keys}
                items={inSearch ? reportDetails : []}
                translation={"report_details"}
                config={{ key: "CURDATE", direction: "descending" }}
                style={{ margin: "0 50px" }}
              />
            </Tab>
          </Tabs>
        }
        {showErrorNotification.show && (
          <ErrorNotification
            text={showErrorNotification.text}
            onClose={() => setShowErrorNotification({ show: false })}
          />
        )}
      </LoadingContainer>
      {showNewReportModal === true && (
        <NewReportDetail
          onClose={setShowNewReportModal}
          selectedReport={selectedReport}
        />
      )}
    </>
  );
};

export default inject(
  "userStore",
  "reportDetailsStore"
)(observer(ReportDetails));
